import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { ProductoService } from '../_services/producto.service';
import { MessageService } from '../_services/message.service';
import { UserService } from '../_services/user.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit {

  idToken = '';
  portalUrl = '';
  mostrarError = false;

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private productoService: ProductoService,
              private messageService: MessageService) {
  }

  ngOnInit(): void {
    let urlParams: any;
    this.activatedRoute.queryParams.subscribe(params => {
      urlParams = {
        idAplicacion: this.activatedRoute.snapshot.paramMap.get('idAplicacion'),
        redirectUrl: params.redirectUrl == undefined ? '' : params.redirectUrl,
        filtroAdicional: params.filtroAdicional == undefined ? '' : params.filtroAdicional
      };

      this.productoService.setCurrentApp(urlParams.idAplicacion);
      this.productoService.setLoginParams(urlParams.idAplicacion, urlParams.filtroAdicional, urlParams.redirectUrl);

      this.authenticationService.cambioProducto(urlParams.idAplicacion, urlParams.filtroAdicional, urlParams.redirectUrl).subscribe(data => {
        
        if (this.limpiarRedirectUrl(urlParams.redirectUrl, urlParams.idAplicacion)) {
          urlParams.redirectUrl = '';
        }

        this.authenticationService.redirectUsuarioLogeado(data, urlParams.redirectUrl);
        }, error => {
          switch (error.status) {
            case 401:
              this.userService.logout();
              break;
            default:
              this.messageService.sendErrorMessage();
              break;
          }
        });
    });
  }

  limpiarRedirectUrl(url: any, idAplicacion: any) {
    if (idAplicacion == environment.idProductoDefecto && (url.includes('https://edp') || url.includes('https://redmatedp'))) {
      return true;
    }
    return false;
  }
}
